import { makeCancellable, takeLatest } from "vuex-cancellable-actions";
import Logger from "./../lib/logger";
import { RepositoryFactory } from "./../repository/RepositoryFactory";
const InundationJsonRepository = RepositoryFactory.get("inundationJson");

export default {
  namespaced: true,
  state: {
    /** 表示範囲の浸水想定区域データ */
    inundations: [],
    /** 表示範囲の浸水想定区域データパラメータ */
    inundationParam: {
      /** 市町村リスト取得時刻 */
      townsAcqTime: null,
    },
    /** 選択中浸水想定区域データ */
    selectedInundationParam: {},
    /** 透過率 [0 - 100%] */
    inundationOpacity: 50,
    /** 表示範囲のハザードマップデータ */
    hazardMap: [],
  },
  mutations: {
    /**
     * API実行時のパラメータを保持
     * @param {*} state
     * @param data
     */
    setInundationParam(state, data) {
      Logger.debug("[inundation]mut - setInundationParam(data)");
      Logger.dir(data);
      state.inundationParam.townsAcqTime = data;
    },
    /**
     * 浸水想定区域一覧をstateに設定
     * @param {*} state
     * @param {*} data
     */
    setInundations(state, data) {
      Logger.debug("[inundation]mut - setInundations(data)");
      Logger.dir(data);
      state.inundations = data;
    },
    /**
     * 選択中浸水想定区域データをstateに設定
     * @param {*} state
     * @param {*} data
     */
    setSelectedInundationParam(state, data) {
      Logger.debug("[inundation]mut - setSelectedInundationParam(data)");
      Logger.dir(data);
      state.selectedInundationParam = data;
    },
    /**
     * 透過率をstateに設定
     * @param {*} state
     * @param {*} opacity
     **/
    setInundationOpacity(state, data) {
      Logger.debug(
        "[inundation]mut - setInundationOpacity(" + data + ")"
      );
      state.inundationOpacity = data;
    },
    /**
     * ハザードマップ一覧をstateに設定
     * @param {*} state
     * @param {*} data
     **/
    setHazardMap(state, data) {
      Logger.debug("[inundation]mut - setHazardMap(data)");
      Logger.dir(data);
      state.hazardMap = data;
    },
  },
  actions: makeCancellable({
    /**
     * 浸水想定区域一覧取得
     *@param towns 市町村リスト
     */

    getInundations: takeLatest(async function ({ state, commit }, { townsAcqTime, towns }) {
      Logger.debug(
        "[inundation]act - getInundations(" + townsAcqTime + ", towns)"
      );
      Logger.dir(towns);
      // 選択中河川格納用
      let selectedData = state.selectedInundationParam;
      // 浸水想定区域一覧格納用
      let inuList = [];
      // ハザードマップ格納用
      let hzrdList = [];
      //河川フラグ
      let riverFlag = false;
      // 市町村コード数だけ処理を繰り返す
      for (let twnCnt = 0; twnCnt < towns.length; twnCnt++) {
        // 浸水想定関連情報を取得
        Logger.debug("[inundation]]API - getInundations(" + towns[twnCnt].id + ")");
        const { data, error } = await InundationJsonRepository.getInundations(towns[twnCnt].id);
        Logger.debug("[inundation]API - getInundations(" + towns[twnCnt].id + ") - retuen");
        Logger.dir(data);
        if (data !== undefined && Object.keys(data.hazardMap).length > 0) {
          hzrdList.push(data.hazardMap)
          Logger.dir(hzrdList);
        }
        if (!error) {
          for (let inuCnt = 0; inuCnt < data.inundation.length; inuCnt++) {
            // 既存データははじく
            if (inuList.find((val) => val.inundationId === data.inundation[inuCnt].inundationId)) {
              continue;
            }
            inuList.push(data.inundation[inuCnt])
          }
          Logger.dir(inuList);
        }
      }
      for (const key in inuList) {
        if (selectedData != undefined && inuList[key].inundationId === selectedData.inundationId) {
          selectedData = inuList[key];
          riverFlag = true;
          break;
        }
      }
      if (!riverFlag || (selectedData != undefined && selectedData != null && !Object.keys(selectedData).length)) {
        selectedData = inuList[0]
      }
      commit("setInundationParam", townsAcqTime);
      commit("setSelectedInundationParam", selectedData);
      commit("setInundations", inuList);
      commit("setHazardMap", hzrdList);
    }),
  }),
};
